import { createRouter, createWebHistory } from 'vue-router'
import axios from "axios";
// import HomeView from '../views/HomeView.vue'

const routes = [
  /*{
    path: '/',
    name: 'home',
    component: HomeView
  },*/
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/main.vue')
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('@/views/main.vue')
  },
  {
    path: '/swu_life',
    name: 'swu_life',
    component: () => import('@/views/swu_life.vue')
  },
  {
    path: '/swu_class',
    name: 'swu_class',
    component: () => import('@/views/swu_class.vue')
  },
  {
    path: '/swu_festival',
    name: 'swu_festival',
    component: () => import('@/views/activity/swu_festival.vue')
  },
  {
    path: '/swu_abc',
    name: 'swu_abc',
    component: () => import('@/views/activity/swu_abc.vue')
  },
  {
    path: '/swu_mission',
    name: 'swu_mission',
    component: () => import('@/views/activity/swu_mission.vue')
  },
  {
    path: '/swu_special',
    name: 'swu_special',
    component: () => import('@/views/activity/swu_special.vue')
  },
  {
    path: '/abc_about',
    name: 'abc_about',
    component: () => import('@/views/abc_about.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginForm.vue')
  },

  {
    path: '/story/:mode/:board_id',
    name: 'story1',
    component: () => import('@/views/story.vue')
  },
  {
    path: '/story/:mode/:board_id/:post_id',
    name: 'story',
    component: () => import('@/views/story.vue')
  },

  {
    path: '/gallery',
    name: 'gallery',
    component: () => import('../views/GalleryView.vue')
  },
  {
    path: '/galleryWrite',
    name: 'galleryWrite',
    component: () => import('../views/GalleryWrite.vue')
  },
  {
    path: '/galleryRead',
    name: 'galleryRead',
    component: () => import('../views/GalleryRead.vue')
  },
  {
    path: '/ask',
    name: 'ask',
    component: () => import('../views/AskView.vue')
  },
  {
    path: '/askWrite',
    name: 'askWrite',
    component: () => import('../views/AskWrite.vue')
  },
  {
    path: '/askRead',
    name: 'askRead',
    component: () => import('../views/AskRead.vue')
  },


  {
    path: '/login_test',
    name: 'login_test',
    component: () => import('@/views/login_test.vue')
  },

  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/Profileform.vue')
  },


  { // 글 목록
    path: '/list/:board_id',
    name: 'board_list',
    component: () => import('@/views/list.vue'),
  },
  { // 글 조회
    path: '/view/:board_id/:post_id',
    name: 'board_view',
    component: () => import('@/views/view.vue'),
  },
  { //글 쓰기
    path: '/write/:board_id',
    name: 'board_write',
    component: () => import('@/views/write.vue'),
  },
  { //글 쓰기
    path: '/modify/:board_id/:post_id',
    name: 'board_modify',
    component: () => import('@/views/write.vue'),
  },

  {
    path: '/faq',
    name: 'faq_list',
    component: () => import('@/views/faq.vue')
  },
  {
    path: '/qna',
    name: 'qna_list',
    component: () => import('@/views/qnaList.vue')
  },
  {
    path: '/qna_view/:qna_idx',
    name: 'qna_view',
    component: () => import('@/views/qnaView.vue')
  },
  {
    path: '/qna_write',
    name: 'qna_write',
    component: () => import('@/views/qnaWrite.vue')
  },

  {
    path: '/adm/member',
    // alias: '/adm/member/:year',
    name: 'AdminMember',
    component: () => import('@/views/adm/AdminMember.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adm/member/:year',
    name: 'AdminMemberYear',
    component: () => import('@/views/adm/AdminMember.vue'),
    meta: { requiresAuth: true },
  },

  {
    path: '/adm/view',
    name: 'AdminView',
    component: () => import('@/views/adm/AdminView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adm/board',
    name: 'AdminBoard',
    component: () => import('@/views/adm/AdminBoard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adm/add',
    name: 'AdminAdd',
    component: () => import('@/views/adm/AdminAdd.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adm/modal',
    name: 'AdminModal',
    component: () => import('@/views/adm/AdminModal.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adm/att',
    name: 'AdminAtt',
    component: () => import('@/views/adm/AdminAtt.vue'),
    meta: { requiresAuth: true },
  },

  { // 임시 게시판 생성
    path: '/adm/create_board',
    name: 'adm_create_board',
    component: () => import('@/views/adm/board_create.vue'),
    meta: { requiresAuth: true },
  },

  { // 출석 체크 임시 게시판
    path: '/in_check',
    name: 'in_check',
    component: () => import('@/views/check.vue'),
    meta: { requiresAuth: true },
  },
  { // 출석 체크 임시 게시판
    path: '/adm/att_list/:idx',
    name: 'attendance_list',
    component: () => import('@/views/adm/attendance_list.vue'),
    meta: { requiresAuth: true },
  },
  { // 출석 체크 임시 게시판
    path: '/adm/tutor_list',
    name: 'tutor_list',
    component: () => import('@/views/adm/tutor_list.vue'),
    meta: { requiresAuth: true },
  },
  { // 출석 체크 임시 게시판
    path: '/adm/meal_list',
    name: 'meal_list',
    component: () => import('@/views/adm/meal_list.vue'),
    meta: { requiresAuth: true },
  },
  { // 슈미션 결과물 좋아요 설정
    path: '/adm/like_config',
    name: 'like_config',
    component: () => import('@/views/adm/like_config.vue'),
    meta: { requiresAuth: true },
  },


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      }
    }
  },
})

router.beforeEach((to, from, next) => {
  // 라우터 가드
  if( to.matched.some( record => record.meta.requiresAuth ) ){
    const url = "/api/login.php"
    const formData = new FormData;
    formData.append('mode', 'tokenCheck');
    try {
      axios.post(url,formData, {
          headers: {
            'authorization2':localStorage.getItem('access_token')
          }
        }).then(function(res) {
        // console.log(res.data);
        if( res.data.err === 0 ){
          // 토큰 저장
          localStorage.setItem('access_token', res.data.access_token);

          next();
        }
        else {
          alert('로그인 후 이용 가능 합니다.');
          next({ name: 'login' });
        }
      })
    } catch (e) {
      console.log(e);
      alert('로그인 후 이용 가능 합니다.');
      next({ name: 'login' });
    }
  }
  else {
    // store.dispatch('getMyInfo').then(r => (console.log(r)));
    /*const token = localStorage.getItem('access_token');
    if( token ){
      store.dispatch('getMyInfo');
    }*/
    next();
  }
})

export default router
